import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from '../App';

const Pagination = ({ page, totalPages, onPageChange }) => {
  const t = useTranslation();
  
  const getVisiblePages = () => {
    const pages = [];
    const delta = 2;
    
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= page - delta && i <= page + delta)
      ) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    
    return pages;
  };

  return (
    <div className="flex items-center justify-between px-2" data-testid="pagination">
      <p className="text-sm text-gray-600">
        {t('page')} {page} {t('of')} {totalPages}
      </p>
      
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          data-testid="prev-page-btn"
        >
          <ChevronLeft size={16} />
          {t('previous')}
        </Button>
        
        <div className="hidden sm:flex items-center gap-1">
          {getVisiblePages().map((p, idx) => (
            p === '...' ? (
              <span key={`ellipsis-${idx}`} className="px-2 text-gray-400">...</span>
            ) : (
              <Button
                key={p}
                variant={page === p ? 'default' : 'ghost'}
                size="sm"
                className={page === p ? '' : ''}
                onClick={() => onPageChange(p)}
                data-testid={`page-${p}-btn`}
              >
                {p}
              </Button>
            )
          ))}
        </div>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          data-testid="next-page-btn"
        >
          {t('next')}
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
